import { createContext, useContext } from "react";
import { State } from "../UserProvider";
import { Company } from "@/types/company";
import { JobPost } from "@/types/jobPost";

export const UserContext = createContext<State>({
  dispatch: () => {},
  user: null,
  userId: null,
  loading: true,
  error: null,
  authToken: null,
  refetchUser: async () => null,
  isAuthenticated: false,
  disabledBasicContent: true,
  disabledProContent: true,
  isSuperUser: false,

  savedJobs: [],
  savedCompanies: [],
  toggleSaveJobPost: () => {},
  toggleFollowCompany: () => {},
  jobPostError: null,
  companyError: null,

  isCompanyFollowed: (_companyId: Company["id"]) => false,
  isJobSaved: (_jobId: JobPost["id"]) => false,
} as State);

export function useUserContext() {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }

  return context;
}
